import { styled } from '@mui/material/styles';

export const Grid = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(6),

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

export const CountryCard = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(6),
  borderRadius: theme.shape.borderRadius * 2,
  border: `1px solid ${theme.palette.black40.main}`,
  transition: '.25s',

  ':hover': {
    borderColor: theme.palette.blue60.main,
    background: theme.palette.blue10.main,
  },
}));

export const SVGWrapper = styled('div')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.black20.main}`,
  marginBottom: theme.spacing(4),
  width: 84,
  height: 56,
  boxSizing: 'content-box',
  overflow: 'hidden',
}));

export const Link = styled('a')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});
